import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import DashboardLayout from "../layout/index";
import StepHeader from "./StepHeader";
import { APP_ROUTES } from "../../constants/approutes";
import { toast } from "react-toastify";
// import CommonLoader from "../../components/CommonLoader";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import FullScreenLoader from "../FullScreenLoader";
import { Select } from "antd";
import ConsentModal from "../Consent/ConsentModal";
import Patientregister from "./Patientregister";
import PatientDetailsdata from "./PatientDetailsdata";
const { Option } = Select;

function PatientView() {
  const navigate = useNavigate();
  const location = useLocation();
  const { patientCode } = location.state || {};
  const searchParams = new URLSearchParams(location.search);
  const from = searchParams.get("from");
  const API_URL = process.env.REACT_APP_API_URL;

  return (
    <>
      <DashboardLayout>
        <div className="min-h-screen px-2 sm:px-4 md:pt-10 bg-white">
          <StepHeader />
          {patientCode ? <PatientDetailsdata /> : <Patientregister />}
        </div>
      </DashboardLayout>
    </>
  );
}

// function InputField({
//   label,
//   name,
//   value,
//   onChange,
//   type = "text",
//   showRequired = true,
//   ...rest
// }) {
//   return (
//     <div className="flex flex-col">
//       <label className="text-sm text-[#004276] mb-1 font-medium">
//         {label}{" "}
//         {showRequired && <span className="text-red-500 text-base">*</span>}
//       </label>
//       <input
//         type={type}
//         name={name}
//         value={value}
//         onChange={onChange}
//         placeholder="Enter here"
//         requir
//         required={showRequired}
//         ed
//         {...rest}
//         className="rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition"
//       />
//     </div>
//   );
// }

function InputField({
  label,
  name,
  value,
  onChange,
  type = "text",
  showRequired = true,
  ...rest
}) {
  const isDateField = name === "dob";

  return (
    <div className="flex flex-col">
      <label className="text-sm text-[#004276] mb-1 font-medium">
        {label}{" "}
        {showRequired && <span className="text-red-500 text-base">*</span>}
      </label>

      {isDateField ? (
        <DatePicker
          value={value ? dayjs(value) : null}
          onChange={(date) =>
            onChange({
              target: {
                name,
                value: date ? date.format("YYYY-MM-DD") : "",
              },
            })
          }
          format="DD-MM-YYYY"
          disabledDate={(current) => current && current > dayjs()}
          placeholder="DD-MM-YYYY"
          className="w-full border border-gray-200 rounded-lg px-3 py-2"
        />
      ) : (
        <input
          type={type}
          name={name}
          value={value}
          onChange={onChange}
          placeholder="Enter here"
          required={showRequired}
          {...rest}
          className="rounded-lg border border-gray-200 px-4 py-2 text-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-[#3cba84] transition"
        />
      )}
    </div>
  );
}

export default PatientView;
